export default class Cells {
    constructor() {
        this.cells = {};
    }
    add(id, cell) {
        if (!this.cells.hasOwnProperty(id)) {
            this.cells[id] = {};
        }
        this.cells[id][cell.getName()] = cell;
    }
    getByID(id) {
        let result = [];
        if (!this.cells.hasOwnProperty(id.toString())) {
            return result;
        }
        let cells = this.cells[id.toString()];
        Object.keys(cells).forEach(name => result.push(cells[name]));
        return result;
    }
    getAll() {
        let results = [];
        Object.keys(this.cells).forEach(id => {
            let cells = this.cells[id];
            Object.keys(cells).forEach(name => results.push(cells[name]));
        });
        return results;
    }
    getByName(name) {
        let results = [];
        Object.keys(this.cells).forEach(id => {
            let cells = this.cells[id];
            Object.keys(cells).forEach(column_name => {
                if (name === column_name) {
                    results.push(cells[column_name]);
                }
            });
        });
        return results;
    }
    get(id, name) {
        return this.cells.hasOwnProperty(id.toString()) ? this.cells[id][name] : null;
    }
}
